/**
 * @desc 红人领用管理-审批
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(
  body: defs.kol.UserCelebrityApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/useCelebrity/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
